import { render, staticRenderFns } from "./credit-report-table.vue?vue&type=template&id=b817fb76"
import script from "./credit-report-table.vue?vue&type=script&lang=js"
export * from "./credit-report-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports